package com.example.mystybag.sharedmodels.project.responseModels.nomenclatures

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable

@Serializable
data class GetSearchRankingConfigResponseModel(
    val configs: List<SearchRankingConfigModel> = emptyList()
) : BaseResponseModel()

@Serializable
data class SearchRankingConfigModel(
    val categoryName: String,
    val alphaCat: Double,
    val betaLoc: Double,
    val intentPenalty: Double,
    val keywordBoostPerHit: Double,
    val maxKeywordBoost: Double,
    val minCatScore: Double,
    val preferredCategoryBoost: Double = 0.0,
    val preferredCategories: List<Long> = emptyList()
)
